import { render, staticRenderFns } from "./OperationChildStatus.vue?vue&type=template&id=130c400c&scoped=true"
import script from "./OperationChildStatus.vue?vue&type=script&lang=ts"
export * from "./OperationChildStatus.vue?vue&type=script&lang=ts"
import style0 from "./OperationChildStatus.vue?vue&type=style&index=0&id=130c400c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130c400c",
  null
  
)

export default component.exports